// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_3i2q"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Files/FileUploadModal/FileUploadModal.scss
// module id = 1MU2
// module chunks = 0